import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export default function SymbolActionModal({
  isOpen,
  onClose,
  selectedSymbol,
  handleDelete,
}) {
  const navigate = useNavigate();

  const actions = [
    "Trade",
    // "Chart",
    // "Details",
    // "Statistics",
    "Depth Of Market",
    "Delete",
    "Cancel",
  ];

  const onDelete = () => {
    handleDelete();
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Background Blur Overlay */}
          <motion.div
            className="fixed inset-0 bg-black/40 z-40"
            onClick={onClose}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Centered Glass Modal */}
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ type: "spring", stiffness: 200, damping: 20 }}
          >
            <div className="w-[80%] max-w-sm bg-[var(--background)] shadow-2xl rounded-3xl border-2 border-[var(--hover)] flex flex-col items-stretch overflow-hidden">
              <div className="text-center font-semibold text-[var(--text)] py-4 mb-3 border-b border-white/30">
                <div className="extralarge font-bold">
                  {selectedSymbol.symbol_display}
                </div>
                <div className="smalltext font-semibold">
                  {selectedSymbol.symbol_name}
                </div>
              </div>

              {actions.map((item, i) => (
                <button
                  key={i}
                  onClick={() => {
                    if (item === "Cancel") return onClose();
                    if (item === "Trade") {
                      window.symboldata = selectedSymbol; // ✅ for quick access
                      localStorage.setItem(
                        "symboldata",
                        JSON.stringify(selectedSymbol)
                      ); // ✅ persist across reloads
                      return navigate("/BuySell");
                    }
                    if (item === "Chart") {
                      window.symboldata = selectedSymbol; // ✅ for quick access
                      localStorage.setItem(
                        "symboldata",
                        JSON.stringify(selectedSymbol)
                      ); // ✅ persist across reloads
                      return navigate("/Chart");
                    }
                    if (item === "Details") {
                      window.symboldata = selectedSymbol; // ✅ for quick access
                      localStorage.setItem(
                        "symboldata",
                        JSON.stringify(selectedSymbol)
                      ); // ✅ persist across reloads
                      return navigate("/Details");
                    }
                    if (item === "Statistics") {
                      window.symboldata = selectedSymbol; // ✅ for quick access
                      localStorage.setItem(
                        "symboldata",
                        JSON.stringify(selectedSymbol)
                      ); // ✅ persist across reloads
                      return navigate("/Statistics");
                    }

                    if (item === "Depth Of Market") {
                      window.symboldata = selectedSymbol; // ✅ for quick access
                      localStorage.setItem(
                        "symboldata",
                        JSON.stringify(selectedSymbol)
                      ); // ✅ persist across reloads
                      return navigate("/MarketDepth");
                    }
                    if (item === "Delete") return onDelete();

                    console.log(
                      `${item} clicked for ${selectedSymbol.symbol_display}`
                    );
                  }}
                  className={`py-3 font-bold rounded-3xl bg-[var(--hover)] ml-5 mr-5 mb-3 text-base transition-all duration-200 
                    ${
                      item === "Delete"
                        ? "text-[var(--sellmeta)]"
                        : item === "Trade"
                        ? "text-[var(--buymeta)]"
                        : "text-[var(--text)]"
                    }`}
                >
                  {item}
                </button>
              ))}
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
